import { CabButton } from "@CabComponents/CabButton";
import { Box, Grid } from "@mui/material";
import { ReactElement, ReactNode } from "react";
import { IoArrowBack } from 'react-icons/io5';
import { CabIcon } from "@CabComponents/CabIcon";


interface StepWrapperProps {
  children: ReactNode;
  onBack: () => void;
  hideBackButton?: boolean;
}

const StepWrapper = ({ children, onBack, hideBackButton }: StepWrapperProps): ReactElement => (
  <Box
    sx={{
      paddingLeft: 4,
      paddingRight: 4,
      paddingTop: 10,
      width: "100%",
      paddingBottom: 4
    }}>
    <Grid container>
      <Grid size={{ xs: 12, md: 1 }} sx={{
        width: { xs: '100%' }
      }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: 'unset' },
            marginBottom: 3
          }}>
          {!hideBackButton && (
            <CabButton
              onClick={onBack}
              icon={<CabIcon Icon={IoArrowBack} />}
              buttonType="tertiary"
              color="accent"
              size="small"
            >
              Back
            </CabButton>
          )}
        </Box>
      </Grid>

      <Grid size={{ xs: 12, md: 10 }}>
        {children}
      </Grid>

      <Grid size={{ xs: 12, md: 1 }}>
      </Grid>
    </Grid>
  </Box>
);

export default StepWrapper;
